import React, { useCallback } from 'react'
import useReactRouter from 'use-react-router'
import Modal from 'core/elements/modal'
import Text from 'core/elements/Text'
import Button from 'core/elements/button'
import useUpdateAction from 'core/hooks/useUpdateAction'
import { routes } from 'core/utils/routes'
import { deletePodDisruptionBudget } from './actions'
import usePluginRouter from 'core/hooks/usePluginRouter'

export default function DeletePodDisruptionBudgetDialog({ rows: [podDisruptionBudget], onClose }) {
  const { history } = useReactRouter()
  const { currentPluginId } = usePluginRouter()
  const routePath = currentPluginId === 'kubevirt' ? 'kubevirtConfiguration' : 'configuration'
  const { update: deleteFn, updating: deletingPodDisruptionBudget } = useUpdateAction(
    deletePodDisruptionBudget,
  )

  const handleDelete = useCallback(async () => {
    await deleteFn(podDisruptionBudget)
    onClose(true)
    history.push(routes[routePath].podDisruptionBudgets.list.path())
  }, [podDisruptionBudget, routePath])

  return (
    <Modal
      panel="dialog"
      open
      onClose={onClose}
      title={`Remove Pod Disruption Budget "${podDisruptionBudget?.name}" ?`}
      maxWidth={600}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={deletingPodDisruptionBudget}>
            Cancel
          </Button>
          <Button onClick={handleDelete} loading={deletingPodDisruptionBudget}>
            Delete
          </Button>
        </>
      }
    >
      <Text variant="body2">Your data will be lost since this action cannot be undone.</Text>
    </Modal>
  )
}
